import { SUPPORTED_DESTINATION_IDS } from 'home/constants'
import { getSupportedDestinationFromPathname } from 'home/getSupportedDestinationFromPathname'
import { capitalise } from 'lib/string/stringUtils'

export function getDestinationLandingSearchItem(pathname: string): App.SearchItem | undefined {
  const destination = getSupportedDestinationFromPathname(pathname)
  if (!destination) return undefined

  return {
    searchType: 'destination',
    value: SUPPORTED_DESTINATION_IDS[destination],
    format: {
      mainText: capitalise(destination),
    },
  }
}
